import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export default function CtaBlock() {
    return (
        <section
            data-testid="cta-block"
            className="relative bg-lime text-forest-900 py-24 md:py-40 overflow-hidden"
        >
            <div className="pointer-events-none absolute inset-0 opacity-[0.08]">
                <div className="mx-auto max-w-[1440px] h-full px-6 md:px-10 grid grid-cols-12">
                    {Array.from({ length: 12 }).map((_, i) => (
                        <div key={i} className="border-l border-forest-900/40 h-full" />
                    ))}
                </div>
            </div>

            <div className="relative mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 items-center gap-10">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.1, ease: EASE }}
                    className="md:col-span-8"
                >
                    <div className="flex items-center gap-4 mb-6">
                        <span className="h-px w-10 bg-forest-900" />
                        <span className="font-mono-mini text-[10px] tracking-[0.42em] uppercase text-forest-900/70">
                            Come visit — 06 cities
                        </span>
                    </div>
                    <h2 className="font-serif-display text-5xl md:text-[6.5rem] lg:text-[8rem] leading-[0.9] tracking-tight text-forest-900">
                        Walk a KLiving <em className="italic">home.</em>
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.1, ease: EASE, delay: 0.1 }}
                    className="md:col-span-4 flex md:justify-end"
                >
                    <Link
                        to="/contact"
                        data-testid="cta-book-visit"
                        className="group inline-flex items-center gap-5 bg-forest-900 text-ivory pl-8 pr-4 py-4 md:pl-10 md:pr-5 md:py-5 hover:bg-ink transition-colors"
                    >
                        <span className="font-mono-mini text-[11px] tracking-[0.32em] uppercase">
                            Book a site visit
                        </span>
                        <span className="h-11 w-11 bg-lime text-forest-900 flex items-center justify-center group-hover:rotate-45 transition-transform duration-500">
                            <ArrowUpRight size={18} strokeWidth={1.5} />
                        </span>
                    </Link>
                </motion.div>
            </div>
        </section>
    );
}
